import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum ConnectionKebabInteractionOption {
  AddConnection = "add_connection",
  AddManagedConnection = "add_managed_connection",
  ChangeOwner = "change_owner",
  CopyId = "copy_id",
  Delete = "delete",
  DiscoverUseCases = "discover_use_cases",
  Reconnect = "reconnect",
  Rename = "rename",
  Share = "share",
  Replace = "replace",
  TestConnection = "test_connection",
  ViewZaps = "view_zaps",
}

export function useEmitConnectionKebabInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: ConnectionKebabInteractionOption) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.ConnectionKebab,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
